<script setup lang="ts">
const props = defineProps<{
    medias: string[]
}>()

// media helpers
const isImage = (url) => /\.(jpe?g|png|gif|svg)$/i.test(url)
const isAudio = (url) => /\.(mp3|wav|ogg|opus)$/i.test(url)
const isVideo = (url) => /\.(mp4|avi)$/i.test(url)
</script>

<template>
    <!-- Medias -->
    <div v-if="medias?.length" class="space-y-4">
        <div v-for="(url, idx) in medias" :key="idx" class="media-container">
            <img
                v-if="isImage(url)"
                :src="`/medias/${url}`"
                alt="Étape image"
                class="max-w-full rounded shadow"
            />
            <audio
                v-else-if="isAudio(url)"
                :src="`/medias/${url}`"
                controls
                class="w-full rounded shadow"
                :autoplay="idx === 0"
            >
                Votre navigateur ne supporte pas la lecture audio.
            </audio>
            <video
                v-else-if="isVideo(url)"
                :src="`/medias/${url}`"
                controls
                class="w-full rounded shadow"
                :autoplay="idx === 0"
            >
                Votre navigateur ne supporte pas la lecture vidéo.
            </video>
        </div>
    </div>
</template>

<style scoped>

</style>
